import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Loader, Flex, Text, Box, Group, Button, Stack } from "@mantine/core";
import { GalleryEffortList, OrgGalleryLocationSelect } from "./";
import { IconCircleMinus } from "@tabler/icons-react";
import initializeGtm from "@util/initializeGtm";
import sendGtmEvent from "@util/sendGtmEvent";
import initializeMetaPixel from "@util/initializeMetaPixel";
import sendMetaPixelEvent from "@util/sendMetaPixelEvent";

const introTextProps = {
  align: "center",
  size: "md",
  fw: 400,
};

export default function OrgGalleryPreSelectedEffort({ orgId, effortData }) {
  // const [effortData, setEffortData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [location, setLocation] = useState(null);
  const [searchParams] = useSearchParams();
  const preSelectedEffortId = searchParams.get("campaign_effort_id");
  const dealerNumber = searchParams.get("third_party_location_id");
  if (!effortData) return null;

  const isRideChallenge = effortData.variety === 6;

  useEffect(() => {
    if (isRideChallenge) {
      initializeGtm("AW-1017383762").then(() => {
        sendGtmEvent('event', 'conversion', {
          allow_custom_scripts: true,
          send_to: "DC-6286727/hdus/hdlrc0+standard",
        })
      });
      initializeMetaPixel("2120270034897755").then(() => {
        sendMetaPixelEvent("track", "PageView");
      });
    }
  }, []);

  useEffect(() => {
    fetchEffortData();
  }, [preSelectedEffortId]);

  useEffect(() => {
    if (dealerNumber) {
      fetchDealerData();
    }
  }, [dealerNumber])

  function fetchEffortData() {
    setLoading(false);
  }

  function navigateToMicrosite(loc) {
    if (!loc.url_code) return;
    window.location = `/entry/${loc.url_code
      }${makeSearchParamsStringForMicrosite()}`;
  }

  function makeSearchParamsStringForMicrosite() {
    const gigyaId = searchParams.get("state");
    const hogId = searchParams.get("member_id");

    const params = [];
    if (gigyaId) params.push(`gigya_id=${gigyaId}`);
    if (hogId) params.push(`hog_id=${hogId}`);

    if (params.length > 0) return `?${params.join("&")}`;
    return "";
  }

  function fetchDealerData() {
    axios.post(`/gallery/retrieve-location-by-third-party-ident/`, {
      third_party_ident: dealerNumber,
      campaign_effort_id: preSelectedEffortId,
    }).then(({ data }) => {
      navigateToMicrosite(data.response[0]);
    }).catch((err) => {
      //
    })
  }

  if (loading)
    return (
      <Flex justify="center" align="center" h="100vh">
        <Loader />
      </Flex>
    );

  return (
    <div>
      {isRideChallenge && <Stack mb="lg">
        <Text {...introTextProps} fw={600} size="lg">Welcome to the 2026 Let’s Ride Challenge®<br />All Bikes, All Riders. All for Heroes.</Text>
        <Text {...introTextProps}>The Let's Ride Challenge brings riders together with one bold goal: 100,000,000 miles to unlock a $1 million donation supporting our nation's heroes. Every mile counts. Every ride matters.</Text>
        <Text {...introTextProps}>Log your miles. Support a cause bigger than yourself.</Text>
        <Text {...introTextProps}>You're three quick steps away from joining the challenge.</Text>
        <Text {...introTextProps}>Step 1: Choose Your Dealership</Text>
        <Text {...introTextProps}>Select the dealership where your miles will be tracked and celebrated all challenge long.</Text>
      </Stack>}
      {/* <Text align="center" mb="sm" mt="lg" size="xl" fw={600}>
        Find a participating dealer for <br />
        {effortData.title}
      </Text> */}
      {location ? (
        <>
          <Group justify="center" mb="lg">
            <Button
              radius="xl"
              onClick={() => setLocation(null)}
              rightSection={<IconCircleMinus size={16} />}
              variant="light"
              size="sm"
            >
              {location.name}
            </Button>
          </Group>
        </>
      ) : (
        <OrgGalleryLocationSelect
          orgId={orgId}
          reqData={{
            organization_id: orgId,
            campaign_effort_id: preSelectedEffortId,
          }}
          searchText={isRideChallenge ? "Search dealerships" : "Search locations"}
          noLocationsText={isRideChallenge ? "We found no dealerships" : "We found no locations"}
          onLocationSelect={(loc) => {
            navigateToMicrosite(loc);
          }}
        />
      )}
      {location && (
        <Box>
          <GalleryEffortList
            items={[
              {
                ...effortData,
                url_code: `${location.url_code
                  }${makeSearchParamsStringForMicrosite()}`,
              },
            ]}
          />
        </Box>
      )}
    </div>
  );
}
